import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { Product, Shipping, User, PaymentMethod } from '@vestiaire/api-sdk-angular';
import { UserService } from '@app/core/user';
import { environment } from '@env/environment';

@Component({
  selector: 'vc-desc-reassurance',
  templateUrl: './desc-reassurance.component.html',
  styleUrls: ['./desc-reassurance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DescReassuranceComponent implements OnChanges {
  @Input()
  product: Product;
  @Input()
  shipping: Shipping;
  @Input()
  user: User | null;
  @Input()
  paymentMethod: PaymentMethod[];
  @Input()
  directShippingEligible: boolean;

  showNewShippingFees = environment.feature.shipping_fees_product_page; // TODO remove config when active
  modifierClass = 0;
  shippingFeesLowAmount = '0';
  shippingFeesHighAmount = '0';

  constructor(private helpersService: HelpersService, private userService: UserService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shipping) {
      this.shipping = changes.shipping.currentValue;
      this.setShippingFeesValues();
    }
  }

  setShippingFeesValues() {
    if (this.shipping && this.shipping.cost) {
      this.shippingFeesLowAmount = this.shipping.cost.lowAmount.formatted;
      this.shippingFeesHighAmount = this.shipping.cost.highAmount.formatted;
    }
  }

  toggleAccordionClass(event) {
    this.modifierClass = this.helpersService.toggleAccordionOpenClass(event);
  }

  get isPremium(): boolean {
    return this.userService.isPremium(this.user);
  }

  /**
   * @todo implement me!
   */
  openModalReturnsParticular() {}

  /**
   * @todo implement me!
   */
  openModalReturnsPro() {}
}
